import styles from './CmsHeading.module.scss';
import React from 'react';
import { Heading } from '@wienenergiegithub/ui-next';

const CmsHeading = ({
  type,
  isTracker,
  content,
  id,
  noSpacing,
  displaySize,
  align = null,
  groupTheme,
}) => {
  if (isTracker) {
    return null;
  }

  return (
    <Heading
      align={align}
      aria-hidden={isTracker}
      as={type}
      className={styles.scrollMargin}
      dangerouslySetInnerHTML={{ __html: content }}
      id={id}
      noSpacing={noSpacing}
      size={displaySize}
      theme={groupTheme}
    />
  );
};
CmsHeading.noMargin = true;
export default CmsHeading;
